import { render, staticRenderFns } from "./sunNav.vue?vue&type=template&id=27db88d7&scoped=true&"
import script from "./sunNav.vue?vue&type=script&lang=js&"
export * from "./sunNav.vue?vue&type=script&lang=js&"
import style0 from "./sunNav.vue?vue&type=style&index=0&id=27db88d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27db88d7",
  null
  
)

export default component.exports